exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth-form[data-v-62326629]{padding:0!important}.submit-btn[data-v-62326629]{background:#c52a49!important;border-radius:6px;color:#fff!important;font-weight:800;height:46px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62326629","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/login/components/register.vue
// module id = 117
// module chunks = 0